import React, { useEffect } from "react";
import PropTypes from "prop-types";
import identifyUser from "../../utils/gainsightUserData";

// note: this component is ignored in unit test coverage report
// since it requires such extensive mocking of DOM elements/events/listeners
// that it defeats the purpose of the unit test
// the functionality of this component is tested in the synthetic test setup for gainsight in datadog
const GainsightService = ({ gainsightUserData }) => {
  useEffect(() => {
    const firstGainsightScriptElement = document.getElementById(
      "first-gainsight-script"
    );
    const secondScriptHandler = (secondGainsightScriptElement) => {
      identifyUser(gainsightUserData);
      secondGainsightScriptElement.removeEventListener(
        "load",
        secondScriptHandler
      );
    };
    const firstScriptHandler = () => {
      const secondGainsightScriptElement = document.getElementById(
        "second-gainsight-script"
      );
      secondGainsightScriptElement.addEventListener(
        "load",
        secondScriptHandler(secondGainsightScriptElement)
      );
      firstGainsightScriptElement.removeEventListener(
        "load",
        firstScriptHandler
      );
    };
    if (firstGainsightScriptElement) {
      if (typeof window?.aptrinsic === "undefined" || !window?.aptrinsic) {
        // if the gainsight px tag script has not finished loading yet, window.aptrinsic will be undefined
        // see expressApp.js '<!-- Gainsight PX Tag-->' for reference
        firstGainsightScriptElement.addEventListener(
          "load",
          firstScriptHandler
        );
      } else if (window.aptrinsic && !window?.aptrinsic.init) {
        // if the gainsight px tag script has finished loading but window.aptrinsic.init is not yet defined/set to true
        // we need to wait for the second script tag to finish loading before a successful user identify call can be made
        // otherwise we will end up dropping user data
        const secondGainsightScriptElement = document.getElementById(
          "second-gainsight-script"
        );
        secondGainsightScriptElement.addEventListener(
          "load",
          secondScriptHandler(secondGainsightScriptElement)
        );
      } else {
        // everything loaded successfully, we can now identify the user
        identifyUser(gainsightUserData);
      }
    }
  }, []);

  return <></>;
};

GainsightService.displayName = "GainsightService";
GainsightService.propTypes = {
  gainsightUserData: PropTypes.object
};
export default GainsightService;
